import React, { useEffect } from 'react'
import { GoogleLogin } from 'react-google-login';
import { useStateValue } from '../../StateProvider';
import styles from './Login.module.css'

function Login() {

    const [{},dispatch] = useStateValue()

    const responseSuccessGoogle = (response) => {
        dispatch({
            type: 'LOGIN_USER',
            userData: response,
        })
      }

      const responseErrorGoogle = (response) => {
        dispatch({
            type: 'LOGOUT_USER',
            userData: {},
        })
      }

      useEffect(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });


    return (
        <div className={styles.component}>

            <div className={styles.cover}>

                <div className={styles.text}>
                    <h1>Why should you login with Google?</h1>

                    <p>This step is necessary because we aim to:</p>
                    
                    <ul>
                    <li>Verify your identity.</li>
                    <li>Maintain the righteousness and novelty of data related to Covid-19 resources on our website.</li>
                    <li>Ban users/email IDs (who are reported for inappropriate behaviour) more efficiently. </li>
                    </ul>
                     <p>Your email is used to avoid data replication and ID verification while adding/reporting the data.</p>

                </div>
                    <GoogleLogin
                        clientId={process.env.REACT_APP_GOOGLE_KEY}
                        buttonText="Login with Google"
                        onSuccess={responseSuccessGoogle}
                        onFailure={responseErrorGoogle}
                        cookiePolicy={'single_host_origin'}
                        className={styles.Button}
                    />

            </div>
        </div>
    )
}

export default Login
